
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { iniTransactionDeletionFilter, ITransactionDeletionFilter } from "@/services";
import {
  PButton,
  PFormDatepickerActions,
  PFormInputHour,
  PFormInputTextSearch,
  PFormSelect,
  SelectType,
} from "@/common/components";
import DateTimeMixin from "@/mixins/datetime";
import { i18n } from "@/i18n";
import TransactionDeletionsUploadModal from "@/components/delete-transactions/transaction-deletions-upload-modal/TransactionDeletionsUploadModal.vue";

@Component({
  name: "transaction-deletions-filter-wrapper",
  components: {
    TransactionDeletionsUploadModal,
    PFormDatepickerActions,
    PFormInputHour,
    PFormSelect,
    PFormInputTextSearch,
    PButton,
  },
  mixins: [DateTimeMixin],
})
export class TransactionDeletionsFilterWrapper extends Vue {
  @Prop({ required: true }) value!: ITransactionDeletionFilter;
  @Watch("value", { immediate: true, deep: true })
  onChangeValue(): void {
    if (this.value) {
      this.valueLocal = JSON.parse(JSON.stringify(this.value));
      this.valueLocal.startDate = new Date(this.valueLocal.startDate);
      this.valueLocal.endDate = new Date(this.valueLocal.endDate);
    }
  }
  language = i18n.locale;
  statusOptions: SelectType[] = [
    { text: i18n.t("delete_transactions_panel.status.PENDING") as string, value: "PENDING" },
    { text: i18n.t("delete_transactions_panel.status.PROCESSED") as string, value: "PROCESSED" },
    {
      text: i18n.t("delete_transactions_panel.status.PROCESSED_WITH_ERRORS") as string,
      value: "PROCESSED_WITH_ERRORS",
    },
    { text: i18n.t("delete_transactions_panel.status.ERROR") as string, value: "ERROR" },
  ];
  valueLocal: ITransactionDeletionFilter = { ...iniTransactionDeletionFilter };
  maxDays = 31;
  timeStart = "00:00";
  timeEnd = "23:59";

  search(): void {
    this.$emit("input", this.valueLocal);
  }

  resetTime(): void {
    this.setTime("00:00", "23:59");
    this.search();
  }
  isIntervalDateValid(): boolean {
    return this.isIntervalValid(this.valueLocal.startDate, this.valueLocal.endDate);
  }
  changeDateStart(): void {
    this.setTime(this.timeStart, this.timeEnd);
    if (this.valueLocal.startDate && !this.isIntervalDateValid()) {
      this.valueLocal.endDate = new Date(this.valueLocal.startDate.getTime());
      this.resetTime();
    }
  }
  changeDateEnd(): void {
    this.setTime(this.timeStart, this.timeEnd);
    if (this.valueLocal.endDate && !this.isIntervalDateValid()) {
      this.valueLocal.startDate = new Date(this.valueLocal.endDate.getTime());
      this.resetTime();
    }
  }
  setTimeFromString(time: string, date: Date, isForEnd = false): void {
    if (time && date) {
      const timeLocal = time.split(":");
      date.setHours(parseInt(timeLocal[0]));
      date.setMinutes(parseInt(timeLocal[1]));
      date.setSeconds(isForEnd ? 59 : 0);
      date.setMilliseconds(isForEnd ? 999 : 1);
    }
  }
  completeTwoDigitsWithZero(value: string): string {
    const timeLocal = value.split(":");
    return ("0" + timeLocal[0]).slice(-2) + ":" + ("0" + timeLocal[1]).slice(-2);
  }
  setTime(timeStart: string, timeEnd: string): void {
    if (this.valueLocal.startDate) this.setTimeFromString(timeStart, this.valueLocal.startDate);
    this.timeStart = this.completeTwoDigitsWithZero(timeStart);
    if (this.valueLocal.endDate) this.setTimeFromString(timeEnd, this.valueLocal.endDate, true);
    this.timeEnd = this.completeTwoDigitsWithZero(timeEnd);
  }
  changeCreditDateHourStart(time: string): void {
    if (this.valueLocal.startDate) this.setTimeFromString(time, this.valueLocal.startDate);
  }
  changeCreditDateHourEnd(time: string): void {
    if (this.valueLocal.endDate) this.setTimeFromString(time, this.valueLocal.endDate, true);
  }
}
export default TransactionDeletionsFilterWrapper;
